import Box from "@mui/material/Box";

import {
  PotsPageCatalogSkeleton,
  PotsSliderSkeleton,
} from "./PotsPageSkeletons";

interface PotsPageLoadingProps {
  className?: string;
}

const PotsPageLoading = ({ className }: PotsPageLoadingProps) =>
  className ? (
    <PotsSliderSkeleton className={className} />
  ) : (
    <PotsPageCatalogSkeleton />
  );

const PotsPageEmpty = () => (
  <Box
    sx={{
      fontSize: { xs: 16, sm: 20 },
      marginBottom: "-20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    No data!
  </Box>
);

export { PotsPageLoading, PotsPageEmpty };
